import { createFileRoute, Link } from "@tanstack/react-router";
import { journalPosts } from "@/data/journal";

function formatJournalDate(isoDate: string) {
  const [year, month, day] = isoDate.split("-").map(Number);
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  }).format(new Date(Date.UTC(year, month - 1, day)));
}

export const Route = createFileRoute("/journal/")({
  head: () => ({
    meta: [
      { title: "Journal — European Wig Luxury" },
      { name: "description", content: "Guides on choosing, wearing, and caring for virgin European hair wigs and toppers — for alopecia, medical hair loss, modest wear, and everyday luxury." },
      { property: "og:title", content: "Journal — European Wig Luxury" },
      { property: "og:description", content: "Guides on choosing, wearing, and caring for virgin European hair wigs and toppers." },
      { property: "og:url", content: "https://europeanwigluxury.com/journal" },
    ],
    links: [{ rel: "canonical", href: "https://europeanwigluxury.com/journal" }],
  }),
  component: JournalIndex,
});

function JournalIndex() {
  return (
    <div className="container-luxe py-16 md:py-24">
      <div className="max-w-2xl">
        <p className="eyebrow">Journal</p>
        <h1 className="mt-3 font-display text-4xl leading-tight md:text-6xl">Notes on hair, cap, and craft.</h1>
        <p className="mt-6 text-lg leading-relaxed text-foreground/80">
          Honest guides on virgin European hair, hand-tied construction, and choosing a piece that fits your life — written by the team who makes them.
        </p>
      </div>

      <ul className="mt-16 grid gap-10 border-t border-border/70 pt-10 md:grid-cols-2 md:gap-x-12 md:gap-y-14">
        {journalPosts.map((post) => (
          <li key={post.slug}>
            <Link to="/journal/$slug" params={{ slug: post.slug }} className="group block">
              <p className="eyebrow">{post.category}</p>
              <h2 className="mt-3 font-display text-2xl leading-tight transition-colors group-hover:text-bronze md:text-3xl">
                {post.title}
              </h2>
              <p className="mt-4 text-base leading-relaxed text-foreground/75">{post.excerpt}</p>
              <p className="mt-4 text-sm text-muted-foreground">
                {formatJournalDate(post.date)} &middot; {post.readingTime}
              </p>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
